import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-QC1HS5W968";

let initialized = false;

export const initGA = (): void => {
  if (!initialized) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    initialized = true;
  }
};

export const trackEvent = (
  eventName: string,
  params: Record<string, any> = {}
): void => {
  if (!initialized) {
    initGA();
  }

  ReactGA.event(eventName, params);
};